import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events } from 'ionic-angular';
import { BibItem } from '../../providers/item/item';
import { AppState } from '../../config/state';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';

/**
 * Generated class for the CoDigitalItemPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-digital-item',
  templateUrl: 'co-digital-item.html',
})
export class CoDigitalItemPage {
  private novelistDetails: any = {};
  private bibDetails: any;
  private style: string = "standard";
  private sharedScreen: boolean = false;
  previousItems: Array<any> = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, private events : Events, private state : AppState, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.novelistDetails = this.navParams.get('novelistDetails');
    this.bibDetails = this.navParams.get('bibDetails');
    // console.log(this.bibDetails);
    if(this.navParams.get('style'))this.style = this.navParams.get('style');
    this.sharedScreen = this.state.sharedScreen;
  }
  closeModal() {
    this.navCtrl.pop();
  }
  addItemToPreviousItemsArray(book){
    this.previousItems.push(book);
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-digital-item/co-digital-item.ts